
export const soundResources = [
  {
    src: 'game/sounds/spinWheelButton.mp3',
    path: 'game/sounds/spinWheelButton.mp3',
    name: "spinWheelButton",
    autoplay: false,
    html5: true,
  },
  {
    src: 'game/sounds/wheelSpinning.mp3',
    path: 'game/sounds/wheelSpinning.mp3',
    name: "wheelSpinning",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/reelStop.mp3',
    name: "ReelStop",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/spinButton.mp3',
    name: "SpinButton",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/wildSymbol.mp3',
    name: "WildSymbol",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/bigWinSound.mp3',
    name: "BigWinSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/megaWinSound.mp3',
    name: "MegaWinSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/epicWinSound.mp3',
    name: "EpicWinSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/superWinSound.mp3',
    name: "SuperWinSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/maxWinSound.mp3',
    name: "MaxWinSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/wildOpeningSound.mp3',
    name: "WildOpeningSound",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/amountIncrease.mp3',
    name: "AmountIncrease",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/backgroundMusic.mp3',
    name: "BackgroundMusic",
    autoplay: true,
    loop: true,
    html5: true,
  },
  {
    path: 'game/sounds/jackpotBackgroundMusic.mp3',
    name: "JackpotBackgroundMusic",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/illuminations.mp3',
    name: "JackpotIlluminations",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/sceneTransition.mp3',
    name: "JackpotSceneTransition",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/suitAppearance.mp3',
    name: "JackpotSuitAppearance",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/suitTransfer.mp3',
    name: "JackpotSuitTransfer",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/winPopUp.mp3',
    name: "JackpotWinPopUp",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/jackpot_Symbol.mp3',
    name: "JackpotSymbol",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/scatter1.mp3',
    name: "Scatter1",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/scatter2.mp3',
    name: "Scatter2",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/scatter3.mp3',
    name: "Scatter3",
    autoplay: false,
    html5: true,
  },

  {
    path: 'game/sounds/scatter4.mp3',
    name: "Scatter4",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/scatter5.mp3',
    name: "Scatter5",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/winningLineSound1.mp3',
    name: "WinningLineSound1",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/winningLineSound2.mp3',
    name: "WinningLineSound2",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/winningLineSound3.mp3',
    name: "WinningLineSound3",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/winningLineSound4.mp3',
    name: "WinningLineSound4",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/openWheel.mp3',
    name: "openWheel",
    autoplay: false,
    html5: true,
  },
  {
    path: 'game/sounds/wheelWinPopup.mp3',
    name: "wheelWinPopup",
    autoplay: false,
    html5: true,
  },
];